import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider } from "antd";
import React from "react";

import AppRoutes from "./AppRoutes";
import "./App.css";
import { isProductionHost } from "./consts";
import "./fonts.css";
import { useGoogleAnalytics } from "./hooks/useGoogleAnalytics";

if (isProductionHost) {
  Sentry.init({
    dsn: "https://d876d1365c88ba1966a6628591880153@o4509946277068800.ingest.de.sentry.io/4509946282049616",
    sendDefaultPii: false,
  });
}

const queryClient = new QueryClient();

// Ant-компоненты используют свой fontFamily токен, а не body — задаём его тут.
const FONT_FAMILY = '"PF DinDisplay Pro", "Sofia Sans", sans-serif';

const App: React.FC = () => {
  useGoogleAnalytics();

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider theme={{ token: { fontFamily: FONT_FAMILY } }}>
        <AppRoutes />
      </ConfigProvider>
    </QueryClientProvider>
  );
};

export default App;
